import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { CheckCircle2, Loader2 } from 'lucide-react'
import { Badge } from './ui/Badge'

const BADGE_CLASS =
    'tw-text-[10px] tw-border-neutral-300 dark:tw-border-neutral-600 tw-text-neutral-500 dark:tw-text-neutral-400 tw-bg-neutral-50 dark:tw-bg-neutral-800/50 tw-gap-1 tw-py-0.5 tw-px-1.5'

const config = {
    saving: {
        icon: <Loader2 className="tw-w-2.5 tw-h-2.5 tw-animate-spin" />,
        label: 'Saving',
        cls: BADGE_CLASS,
    },
    error: {
        icon: null,
        label: 'Error',
        cls: 'tw-text-[10px] tw-border-red-300 dark:tw-border-red-600 tw-text-red-500 dark:tw-text-red-400 tw-bg-red-50 dark:tw-bg-red-800/50 tw-gap-1 tw-py-0.5 tw-px-1.5',
    },
    unsaved: { icon: null, label: 'Unsaved', cls: BADGE_CLASS },
    saved: {
        icon: <CheckCircle2 className="tw-w-2.5 tw-h-2.5" />,
        label: 'Saved',
        cls: BADGE_CLASS,
    },
}

export function SaveBadge({ status }) {
    const { icon, label, cls } = config[status] || config.saved

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={status}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.15 }}
            >
                <Badge variant="outline" className={cls}>
                    {icon}
                    {label}
                </Badge>
            </motion.div>
        </AnimatePresence>
    )
}
